import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateLinkedCaseRuleMutation,
  CreateLinkedCaseRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const CreateLinkedCaseRule = gql`
  mutation createLinkedCaseRule(
    $code: String!
    $name: String!
    $description: String!
    $identifierPath: IdentifierPathInput!
    $caseTypeCode: String!
    $linkedCaseType: String
    $linkedCaseConditions: [LinkedCaseConditionInput!]
  ) {
    createLinkedCaseRule(
      input: {
        code: $code
        name: $name
        description: $description
        identifierPath: $identifierPath
        caseTypeCode: $caseTypeCode
        linkedCaseType: $linkedCaseType
        linkedCaseConditions: $linkedCaseConditions
      }
    ) {
      ...RuleFragment
    }
  }

  ${ruleFragment}
` as TypedDocumentNode<CreateLinkedCaseRuleMutation, CreateLinkedCaseRuleMutationVariables>;
